import { HOME } from "./types";
const initialState = { active: false };

export default function(state = initialState, action) {
  switch (action.type) {
    case HOME.UPDATE_FIELD:
      return {
        ...state,
        [action.field]: action.val
      };
    default:
      return state;
  }
}
